import { render } from "./PlatoonDropdownV2.vue?vue&type=template&id=05f704a3"
import script from "./PlatoonDropdownV2.vue?vue&type=script&lang=js"
export * from "./PlatoonDropdownV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__